import { BidsTable } from "@/components/BidsTable"

export function BidsPage() {
  return (
    <div className="flex flex-col h-full">
      <BidsTable />
    </div>
  )
}
